import React from 'react';
import Skeleton from './Skeleton.jsx';

const OffsiteSessionLoadingCard = () => (
  <article className="offsite-session-card offsite-session-card--loading" aria-hidden="true">
    <div className="offsite-session-card__date">
      <Skeleton width={34} height={58} />
    </div>
    <div className="offsite-session-card__content">
      <Skeleton width={88} height={13} />
      <Skeleton width="54%" height={20} />
      <Skeleton width="42%" height={16} />
    </div>
    <div className="offsite-session-card__action">
      <Skeleton width={116} height={16} />
      <Skeleton width={144} height={48} />
    </div>
  </article>
);

export const OffsiteDiscoveryLoading = ({ calendarCellCount = 42 }) => (
  <div className="offsite-discovery-loading" aria-hidden="true">
    <section className="offsite-location-calendar offsite-calendar--loading">
      <div className="offsite-calendar__header">
        <Skeleton className="offsite-calendar-loading__nav" width={40} height={40} />
        <Skeleton width={148} height={24} />
        <Skeleton className="offsite-calendar-loading__nav" width={40} height={40} />
      </div>
      <div className="offsite-calendar__grid offsite-calendar-loading__grid">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
          <span key={day} className="offsite-calendar__weekday">{day}</span>
        ))}
        {Array.from({ length: calendarCellCount }, (_, index) => (
          <span key={index} className="offsite-calendar-loading__day">
            <Skeleton width={19} height={19} />
          </span>
        ))}
      </div>
      <p className="offsite-calendar__legend">
        <Skeleton className="offsite-calendar-loading__dot" width={9} height={9} />
        <Skeleton width={190} height={14} />
      </p>
    </section>
    <section className="offsite-location-sessions offsite-location-sessions--loading">
      <div className="offsite-session-results__header">
        <Skeleton width="56%" height={24} />
        <Skeleton width={82} height={30} />
      </div>
      {Array.from({ length: 3 }, (_, index) => <OffsiteSessionLoadingCard key={index} />)}
    </section>
  </div>
);

export const OffsiteBookingPreviewLoading = () => (
  <div className="offsite-booking-preview-loading" aria-hidden="true">
    <div className="offsite-booking-panel__session">
      <Skeleton width="62%" height={18} />
      <div className="offsite-booking-preview-loading__facts">
        {[110, 178, 126, 152].map((width, index) => (
          <div key={index}>
            <Skeleton width={68} height={12} />
            <Skeleton width={width} height={16} />
          </div>
        ))}
      </div>
    </div>
    <section className="offsite-booking-panel__map">
      <div className="offsite-booking-panel__map-heading">
        <Skeleton width={126} height={20} />
        <Skeleton width={116} height={16} />
      </div>
      <Skeleton width="88%" height={13} />
      <Skeleton className="offsite-booking-preview-loading__directions" width={128} height={36} />
      <Skeleton className="offsite-booking-preview-loading__map" width="100%" height={170} />
      <Skeleton width={184} height={13} />
    </section>
    <div className="offsite-booking-preview-loading__quantity">
      <Skeleton width={110} height={14} />
      <div className="count-input">
        <Skeleton width={44} height={44} />
        <Skeleton width="100%" height={44} />
        <Skeleton width={44} height={44} />
      </div>
    </div>
    <div className="offsite-booking-panel__preview-total" aria-hidden="true">
      <Skeleton width={156} height={16} />
      <Skeleton width={70} height={18} />
    </div>
    <div className="offsite-booking-preview-loading__button">
      <Skeleton width="100%" height={48} />
    </div>
  </div>
);
